import { LIFE_INSURANCE_STEPS } from '@app/app/esales/life/_sections/steps/LIFE_INSURANCE_STEPS';
import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';

interface LifeStepGtmData {
    step_number: number;
    sub_step_number: number;
}

const LIFE_FUNNEL_STEP_DATA: Record<string, LifeStepGtmData> = {
    [LIFE_INSURANCE_STEPS.START]: { step_number: 0, sub_step_number: 0 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.MAIN_REASON]: { step_number: 1, sub_step_number: 1 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.AGE]: { step_number: 1, sub_step_number: 2 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.INCOME]: { step_number: 1, sub_step_number: 3 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.CHOOSE_PACKAGE]: { step_number: 1, sub_step_number: 4 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.CUSTOM_COVERS]: { step_number: 1, sub_step_number: 4 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.DURATION]: { step_number: 1, sub_step_number: 5 },
    [LIFE_INSURANCE_STEPS.PACKAGE_AND_COVERAGES.PAYMENT_SCHEDULE]: { step_number: 1, sub_step_number: 6 },
    [LIFE_INSURANCE_STEPS.PACKAGES_DONE]: { step_number: 1, sub_step_number: 7 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.PROFESSION]: { step_number: 2, sub_step_number: 1 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.HAS_HOBBIES]: { step_number: 2, sub_step_number: 2 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.HALFWAY_LOGIN]: { step_number: 2, sub_step_number: 2.5 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.TRANSPORTATION]: { step_number: 2, sub_step_number: 3 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.CONTACT_DETAILS]: { step_number: 2, sub_step_number: 4 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.HEALTH_QUESTIONS]: { step_number: 2, sub_step_number: 5 },
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH_DONE]: { step_number: 2, sub_step_number: 6 },
    [LIFE_INSURANCE_STEPS.SUMMARY]: { step_number: 3, sub_step_number: 1 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.TAX_INFORMATION]: { step_number: 4, sub_step_number: 1 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.BENEFICIARIES]: { step_number: 4, sub_step_number: 3 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.INVOICE_INFORMATION]: { step_number: 4, sub_step_number: 4 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT]: { step_number: 4, sub_step_number: 5 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.CONSENTS]: { step_number: 4, sub_step_number: 6 },
};

const LIFE_MID_FORM_STEP_DATA: Record<string, LifeStepGtmData> = {
    [LIFE_INSURANCE_STEPS.LIFESTYLE_AND_HEALTH.HEALTH_QUESTIONS_SUMMARY]: { step_number: 2, sub_step_number: 6 },
    [LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.TAX_INFORMATION_SUMMARY]: { step_number: 4, sub_step_number: 2 },
};

export function getLifeStepGtmData(stepKey: string): Nullable<LifeStepGtmData> {
    return LIFE_FUNNEL_STEP_DATA[stepKey] ?? LIFE_MID_FORM_STEP_DATA[stepKey] ?? null;
}

export function trackLifeFunnelStep(stepKey: string): void {
    const data = LIFE_FUNNEL_STEP_DATA[stepKey];

    if (!data) {
        return;
    }

    pushToDataLayer('funnel_step', {
        flow_name: 'life_insurance',
        ...data,
    });
}
